"use client";

import { useQuery } from "@tanstack/react-query";

interface OwnedStore {
  id: string;
  name: string;
  city?: string | null;
  state?: string | null;
  status: string;
}

interface OwnedStoresResponse {
  ok: boolean;
  stores: OwnedStore[];
  error?: string;
}

async function fetchOwnedStores(): Promise<OwnedStoresResponse> {
  const res = await fetch("/api/dashboard/stores", { credentials: "include" });
  return res.json();
}

export function useOwnedStores() {
  return useQuery({
    queryKey: ["owned-stores"],
    queryFn: fetchOwnedStores,
    staleTime: 30_000,
    retry: false,
  });
}
